module.exports = __webpack_public_path__ + "media/images/home/dash-95c6dbcd4efb1551eefff64bbf69858c.png";